import { useState } from "react";
import { useExportXmlMutation } from "services/api";
import { formatTime } from "utilities/time";

export const useExportXml = ({ projectId, selectedSegments }) => {
  const [isExportingXml, setIsExportingXml] = useState(false);
  const [exportXmlError, setExportXmlError] = useState(null);
  const [exportXml] = useExportXmlMutation();

  const handleExportXml = async () => {
    if (!selectedSegments || selectedSegments.length === 0) return;

    try {
      setIsExportingXml(true);
      const response = await exportXml({
        projectId,
        sequence: selectedSegments.map((segment) => ({
          filename: segment.filename,
          end: formatTime(segment.start),
          start: formatTime(segment.end),
          thumbnailUrl: segment.thumbnailUrl,
        })),
      }).unwrap();

      // Create a blob from the XML text response
      const blob = new Blob([response], {
        type: "application/xml; charset=utf-8",
      });

      // Create a URL for the blob
      const url = URL.createObjectURL(blob);

      // Create a temporary link element
      const link = document.createElement("a");
      link.href = url;
      link.download = "export.xml";

      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the URL
      URL.revokeObjectURL(url);

      setExportXmlError(null);
    } catch (error) {
      console.error("Failed to export to XML:", error);
      setExportXmlError("Failed to export to XML");
    } finally {
      setIsExportingXml(false);
    }
  };

  return {
    isExportingXml,
    exportXmlError,
    handleExportXml,
  };
};

export default useExportXml;
